import React, { useState } from "react";
import "./InternshipPanel.css";

const internships = [

  {
    company: "Indian Oil Corporation Ltd. (IOCL)",
    role: "Winter Intern",
    duration: "Haldia Refinery • Dec 2025",
    desc:
      "Worked on refinery automation, industrial instrumentation, process control systems, grid integration, substation operations and industrial energy management practices.",
  },

  {
    company: "WBPDCL Bakreswar Thermal Power Station",
    role: "Summer Trainee",
    duration: "Jul 2025",
    desc:
      "Monitored thermal power generation, boiler–turbine–generator coordination, electrical protection systems, switchyard operations and high-voltage safety procedures.",
  },

];

const InternshipPanel = () => {

  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <button
        className="internship-float-btn"
        onClick={() => setOpen(!open)}
      >
        💼
      </button>

      {/* Side Panel */}
      <div
        className={`internship-panel ${
          open ? "open" : ""
        }`}
      >

        {/* Header */}
        <div className="panel-header">

          <h2>
            ✨ Industrial Experience
          </h2>

          <button
            onClick={() => setOpen(false)}
          >
            ✖
          </button>

        </div>

        {/* Internship Cards */}
        <div className="internship-list">

          {internships.map((item, index) => (

            <div
              className="internship-card"
              key={index}
            >

              <div className="internship-glow"></div>

              <h3>{item.company}</h3>

              <h4>{item.role}</h4>

              <span>{item.duration}</span>

              <p>{item.desc}</p>

            </div>

          ))}

        </div>

      </div>
    </>
  );
};

export default InternshipPanel;